import { useMutation, useQueryClient } from '@tanstack/react-query';
import { organizationService } from '@services/organization';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useToggleOrganizationStatus = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['organizations', 'toggleStatus'],
    mutationFn: async ({ organizationId, enable }: { organizationId: string; enable: boolean }) => {
      if (enable) {
        return await organizationService.enableOrganization(organizationId);
      } else {
        return await organizationService.disableOrganization(organizationId);
      }
    },
    onSuccess: (_, { enable }) => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      toast.success(enable ? tActionMessages.organizationEnabledSuccessfully : tActionMessages.organizationDisabledStatusSuccessfully);
    },
    onError: (error: any) => {
      console.error('Toggle organization status error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        error?.toString() ||
        'Failed to update organization status';
      toast.error(errorMessage);
    },
  });
};

export default useToggleOrganizationStatus;